import React from "react";
import Marquee from "react-fast-marquee";

export default function CultMarquee({ inverted = false }) {
  const phrases = ["NOT A TREND.", "IT'S A CULT.", "IT'S A LYF.", "EST. 2026", "LIVE DIFFERENT.", "STAY CULT."];
  return (
    <div className={`marquee-wrap ${inverted ? "bg-black text-[#CFF048] border-y border-[#CFF048]" : ""}`} data-testid="cult-marquee">
      <Marquee gradient={false} speed={60} className="py-4">
        {Array(3).fill(0).map((_, i) => (
          <span key={i} className="flex items-center gap-6 px-6 text-xl md:text-3xl tracking-tight">
            {phrases.map((p, j) => (
              <span key={`${i}-${j}`} className="flex items-center gap-6">
                <span>{p}</span>
                <span className="text-2xl">✦</span>
              </span>
            ))}
          </span>
        ))}
      </Marquee>
    </div>
  );
}
